import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth';

export const useSwipeNavigation = (enabled = true) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin } = useAuth();

  // Define page order (only main pages in bottom nav)
  const allPages = [
    '/',
    '/stock-out',
    '/restock',
    '/products',
    '/logs',
    '/users',
  ];

  const adminOnlyPages = ['/restock', '/logs', '/users'];

  // Filter pages based on role
  const availablePages = isAdmin()
    ? allPages
    : allPages.filter(p => !adminOnlyPages.includes(p));

  const currentIndex = availablePages.indexOf(location.pathname);

  const goToNextPage = () => {
    if (!enabled) return;
    if (currentIndex >= 0 && currentIndex < availablePages.length - 1) {
      navigate(availablePages[currentIndex + 1]);
      return true;
    }
    return false;
  };

  const goToPrevPage = () => {
    if (!enabled) return;
    if (currentIndex > 0) {
      navigate(availablePages[currentIndex - 1]);
      return true;
    }
    return false;
  };

  return {
    goToNextPage,
    goToPrevPage,
    canGoNext: currentIndex >= 0 && currentIndex < availablePages.length - 1,
    canGoPrev: currentIndex > 0,
    currentPage: location.pathname,
    isMainPage: availablePages.includes(location.pathname),
  };
};
